import { useDispatch, useSelector } from 'react-redux';

import { ServiceOrderState } from '@mews-commander/data-access';
import { ProductServiceOrder } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropDownButton, DropdownItem, Icon, IconName } from '@optimus-web/core';
import {
    cancelProductServiceOrder,
    processProductServiceOrder,
} from '@mews-commander/legacy-entities/src/actions/productServiceOrders';
import { hasReadOnlyPrivilegesForCompanyData } from '@mews-commander/legacy-entities/src/selectors/session/scope';

const ServiceOrderActionCell = ({ id, state }: Pick<ProductServiceOrder, 'id' | 'state'>) => {
    const readOnly = useSelector(hasReadOnlyPrivilegesForCompanyData);
    const dispatch = useDispatch();

    const canProcess = state === ServiceOrderState.Confirmed;
    const canCancel = state !== ServiceOrderState.Canceled;

    if (!canProcess && !canCancel) {
        return null;
    }

    const handleClickProcessOrder = () => {
        dispatch(processProductServiceOrder({ productServiceOrderId: id }));
    };
    const handleClickCancelOrder = () => {
        dispatch(cancelProductServiceOrder({ productServiceOrderId: id }));
    };

    return (
        <DropDownButton size="small" icon={IconName.More} variant="ghost">
            {canProcess && (
                <DropdownItem
                    leftDetail={<Icon value={IconName.Done} />}
                    onClick={handleClickProcessOrder}
                    label={<LocalizedText textKey={TextKey.Process} />}
                    disabled={readOnly}
                />
            )}
            {canCancel && (
                <DropdownItem
                    leftDetail={<Icon value={IconName.CancelSquare} />}
                    onClick={handleClickCancelOrder}
                    label={<LocalizedText textKey={TextKey.Cancel} />}
                    disabled={readOnly}
                />
            )}
        </DropDownButton>
    );
};

export default ServiceOrderActionCell;
